import React, { useEffect, useRef, useState } from "react";
import styles from "./styles.module.scss";
import ProgressBar from "../_basic/ProgressBar";
import ProgressArrow from "../_basic/ProgressArrow";
import SlideNavigation, { OnNavigationType } from "../_basic/SlideNavigation";
import { ImageUploadSlideType } from "../../../types/imageUploadSlide";

interface ImageUploadSlideProps {
  data: ImageUploadSlideType;
  onNavigation: OnNavigationType;
}

const check = "/icons/check.svg";
const camera = "/icons/camera.svg";

const ImageUploadSlide: React.FC<ImageUploadSlideProps> = ({ data, onNavigation }) => {
  const [categoryIndex, setCategoryIndex] = useState(0);
  const category = data.categories[categoryIndex];

  const canGoNext = (current: number) => {
    return current < data.categories.length - 1;
  };

  const canGoPrev = (current: number) => {
    return current > 0;
  };

  const onNext = () => {
    setCategoryIndex((prev) => (canGoNext(prev) ? prev + 1 : prev));
  };

  const onPrev = () => {
    setCategoryIndex((prev) => (canGoPrev(prev) ? prev - 1 : prev));
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.progressIndicatorContainer}>
        {data.categories.map((icon, index) => {
          return (
            <ProgressArrow
              key={index}
              size={100}
              spacerColor="primary"
              isFirst={index == 0}
              isComplete={categoryIndex > index}
              imageUrl={categoryIndex > index ? check : camera}
            />
          );
        })}
      </div>

      <div className={styles.content}>
        <div className={styles.categories}>
          {data.categories.map((category, index) => (
            <div
              key={index}
              className={`${styles.categoryContainer} ${categoryIndex != index?  styles.hideAfterDelay : ""}`}
              style={{ transform: `translateX(-${categoryIndex * 100}%)`}}
            >
              <h1 className={styles.title}>{category.title}</h1>
              <p> {category.description} </p>
              <h6>{category.exampleLabel}</h6>
              <img
                src={category.exampleImage}
                alt={category.exampleLabel}
                onError={(e) => (e.currentTarget.src = "/logo512.png")}
              />
              <div>
                {category.guidelines.map((item, index) => (
                  <div className={styles.guidelineContainer}>
                    <p key={index}>{`${index + 1}. ${item} `} </p>
                    <h5 className={styles.check}>
                      {category.showGuidelineTickInFront ? "✔" : ""}
                    </h5>
                  </div>
                ))}
              </div>

              <h6>{category.previewImageLabel}</h6>
              <img
                src={category.exampleImage}
                alt={category.exampleLabel}
                onError={(e) => (e.currentTarget.src = "/logo512.png")}
              />
            </div>
          ))}
        </div>
      </div>

      <div className={styles.categorySlider}>
        {canGoPrev(categoryIndex) && (
          <div onClick={onPrev}>{category.slug} next</div>
        )}
        <div className={styles.submitContainer}>{data.uploadButtonLabel}</div>
        {canGoNext(categoryIndex) && (
          <div onClick={onNext}>{category.slug} prev</div>
        )}
      </div>

      <SlideNavigation onNavigation={onNavigation} />
    </div>
  );
};
export default ImageUploadSlide;
